(() => {
  if (customElements.get('tkpv2-carousel')) return;

  class TkpV2Carousel extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-carousel-track]');
      this.controls = this.querySelector('[data-carousel-controls]');
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.cards = new MutationObserver(() => {
        this.track.scrollLeft = 0;
        this.updateImages();
        this.update();
      });
      this.cards.observe(this.track, { childList: true });
      this.updateImages();
      this.update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      this.cards?.disconnect();
      this.events = null;
    }

    updateImages() {
      this.track.querySelectorAll('.tkp__wine-media img').forEach(image => {
        image.sizes = '(max-width: 450px) 78vw, (max-width: 750px) 340px, (max-width: 1280px) 30vw, 385px';
      });
    }

    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = maximum > 2;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = !scrollable;
      this.track.tabIndex = scrollable ? 0 : -1;
      this.previous.disabled = !scrollable || position <= 2;
      this.next.disabled = !scrollable || position >= maximum - 2;
    }

    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const sign = styles.direction === 'rtl' ? -1 : 1;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.track.scrollBy({ left: direction * sign * step, behavior });
    }
  }

  customElements.define('tkpv2-carousel', TkpV2Carousel);
})();
